var _path, _path2, _path3, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrainLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 761,
    height: 700,
    viewBox: "0 0 761 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.81 387.861C214.939 412.422 238.544 428.968 272.825 435.733C307.078 442.491 351.848 439.445 399.006 424.964C446.164 410.483 486.733 387.323 514.206 361.61C541.7 335.876 555.965 307.701 550.836 283.139C545.707 258.578 522.103 242.032 487.822 235.268C453.568 228.509 408.798 231.555 361.64 246.037C314.482 260.518 273.913 283.677 246.441 309.39C218.946 335.125 204.681 363.299 209.81 387.861Z",
    stroke: "url(#paint0_linear_889_460)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.363 411.643C139.842 447.455 174.242 471.525 224.078 481.358C273.886 491.186 338.97 486.755 407.514 465.706C476.059 444.658 535.038 410.992 574.985 373.602C614.955 336.192 635.762 295.169 628.283 259.357C620.805 223.545 586.405 199.475 536.569 189.642C486.761 179.814 421.677 184.245 353.132 205.294C284.588 226.342 225.609 260.008 185.661 297.398C145.691 334.808 124.884 375.831 132.363 411.643Z",
    stroke: "url(#paint1_linear_889_460)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1242 440.582C48.4618 490.084 95.998 523.309 164.761 536.877C233.497 550.439 323.299 544.322 417.867 515.282C512.435 486.242 593.815 439.793 648.943 388.195C704.093 336.576 732.86 279.921 722.522 230.418C712.184 180.916 664.648 147.691 595.885 134.123C527.149 120.561 437.347 126.678 342.779 155.718C248.211 184.758 166.831 231.207 111.703 282.805C56.5531 334.424 27.7866 391.079 38.1242 440.582Z",
    stroke: "url(#paint2_linear_889_460)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_889_460)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 423.874,
    width: 229.465,
    height: 168.08,
    rx: 84.0398,
    transform: "rotate(-49.265 318 423.874)",
    fill: "url(#paint3_linear_889_460)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_889_460)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.803,
    y: 469.975,
    width: 187.703,
    height: 244.211,
    rx: 93.8515,
    transform: "rotate(-141.569 341.803 469.975)",
    fill: "url(#paint4_linear_889_460)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_889_460)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.353,
    y: 355.72,
    width: 143.87,
    height: 158.031,
    rx: 71.9349,
    transform: "rotate(145.17 494.353 355.72)",
    fill: "url(#paint5_linear_889_460)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_889_460",
    x: 152.48,
    y: 84.48,
    width: 608.14,
    height: 614.596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_889_460"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_889_460",
    x: 32.7626,
    y: -0.000976562,
    width: 622.834,
    height: 631.977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_889_460"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_889_460",
    x: 114.192,
    y: 54.1914,
    width: 551.97,
    height: 555.506,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_889_460"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_889_460",
    x1: 539.337,
    y1: 275.878,
    x2: 228.736,
    y2: 382.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_889_460",
    x1: 611.36,
    y1: 248.873,
    x2: 160.077,
    y2: 403.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_889_460",
    x1: 698.998,
    y1: 216.013,
    x2: 76.5327,
    y2: 428.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_889_460",
    x1: 432.733,
    y1: 423.874,
    x2: 432.733,
    y2: 591.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A3F",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A3F",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_889_460",
    x1: 534.565,
    y1: 653.83,
    x2: 292.513,
    y2: 714.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3098C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A3F",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_889_460",
    x1: 642.101,
    y1: 474.693,
    x2: 460.955,
    y2: 528.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A059FD",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F",
    stopOpacity: 0.75
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainLight);
export default __webpack_public_path__ + "static/media/brainLight.81acd8e5f1cbe125b5088bbc8ecc9b28.svg";
export { ForwardRef as ReactComponent };